import React, { Fragment } from "react";

import AddIcon from "react-icons/lib/fa/plus";
import CloseIcon from "react-icons/lib/fa/close";

import { translate } from "react-i18next";

import { Box, Flex, FullWidth, Link, Text } from "src/components";

class CollapsibleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
    };
  }

  static defaultProps = {
    variant: "regular",
    Icon: AddIcon,
  };

  handleToggle = e => {
    e.preventDefault();
    if (!this.state.open && this.props.onOpen) {
      this.props.onOpen();
    }
    this.setState(({ open }) => ({ open: !open }));
  };

  handleClose = ({ messageKey } = {}) => {
    this.setState({ open: false, messageKey });
  };

  componentWillReceiveProps(props) {
    if (props.open) {
      this.setState({ open: props.open });
    }
  }

  render() {
    const { open, messageKey } = this.state;
    const { title, renderTitle, renderForm, variant, Icon, t } = this.props;

    const CurrentIcon = open ? CloseIcon : Icon;

    const variantProps =
      variant === "small"
        ? {
            titleSize: 2,
            iconSize: 18,
          }
        : {
            titleSize: 4,
            iconSize: 22,
          };

    return (
      <Fragment>
        {renderTitle ? (
          renderTitle({
            toggleCollapse: this.handleToggle,
          })
        ) : (
          <Link
            to="#"
            onClick={this.handleToggle}
            color="blue"
            fontSize={variantProps.titleSize}
            fontWeight="semibold"
            textDecoration="none"
          >
            <Flex align="center">
              <Flex mr={1}>
                <CurrentIcon size={variantProps.iconSize} flex={1} />
              </Flex>
              {title}
            </Flex>
          </Link>
        )}
        {open ? (
          <Box mt={2}>
            {renderForm({
              onComplete: this.handleClose,
            })}
          </Box>
        ) : null}
        {messageKey ? (
          <FullWidth mt={3}>
            <Flex p={2} bg="success" justify="center">
              <Text color="white">{t(messageKey)}</Text>
            </Flex>
          </FullWidth>
        ) : null}
      </Fragment>
    );
  }
}

export default translate("translations")(CollapsibleForm);



// WEBPACK FOOTER //
// ./src/banking/components/CollapsibleForm.js